export default function LoaderMineralsGrid() {
  return (
    <div className="grid grid-cols-12 gap-2">
      {[...Array(32)].map((_, index) => (
        <div
          key={index}
          className="col-span-12 flex animate-pulse flex-col md:col-span-6 lg:col-span-4 xl:col-span-3"
        >
          <div className="relative flex h-28 w-full flex-col border-2 border-muted-500 bg-white"></div>
        </div>
      ))}
    </div>
  )
}
